import { gql, DocumentNode } from '@apollo/client';

// 使用更严格的类型定义
export const DOWNLOAD_TASK_DETAIL_EXCEL: DocumentNode = gql`
    mutation DownloadTaskDetailExcel($taskId: Long!) {
        downloadUploadTaskDetail(taskId: $taskId)
    }
`;

// 导出类型定义，便于类型检查
export interface DownloadTaskDetailExcelVariables {
    taskId: number;
}

export interface DownloadTaskDetailExcelResponse {
    downloadUploadTaskDetail: string;
}